/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  GetMedicationsParams,
  MedicationStaffApiOutContract,
  ProblemDetails
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */
export const getMedications = (
    params?: GetMedicationsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MedicationStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/medications`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMedicationsInfiniteQueryKey = (params?: GetMedicationsParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/medications`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetMedicationsQueryKey = (params?: GetMedicationsParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/medications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMedicationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(params?: GetMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedications>>> = ({ signal }) => getMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMedications>>>
export type GetMedicationsInfiniteQueryError = ProblemDetails | ErrorApiOutContract


export function useGetMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params: undefined |  GetMedicationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedications>>,
          TError,
          Awaited<ReturnType<typeof getMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedications>>,
          TError,
          Awaited<ReturnType<typeof getMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */
export const prefetchGetMedicationsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMedicationsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetMedicationsQueryOptions = <TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(params?: GetMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedications>>> = ({ signal }) => getMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMedications>>>
export type GetMedicationsQueryError = ProblemDetails | ErrorApiOutContract


export function useGetMedications<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params: undefined |  GetMedicationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedications>>,
          TError,
          Awaited<ReturnType<typeof getMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedications<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedications>>,
          TError,
          Awaited<ReturnType<typeof getMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedications<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetMedications<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */
export const prefetchGetMedicationsQuery = async <TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMedicationsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetMedicationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedications>>> = ({ signal }) => getMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMedications>>>
export type GetMedicationsSuspenseQueryError = ProblemDetails | ErrorApiOutContract


export function useGetMedicationsSuspense<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params: undefined |  GetMedicationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsSuspense<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsSuspense<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetMedicationsSuspense<TData = Awaited<ReturnType<typeof getMedications>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMedicationsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedications>>> = ({ signal }) => getMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMedications>>>
export type GetMedicationsSuspenseInfiniteQueryError = ProblemDetails | ErrorApiOutContract


export function useGetMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params: undefined |  GetMedicationsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedications>>>, TError = ProblemDetails | ErrorApiOutContract>(
 params?: GetMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieves a specific medication by its identifier.
 */
export const getMedicationsMedicationGlobalKey = (
    medicationGlobalKey: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MedicationStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/medications/${encodeURIComponent(String(medicationGlobalKey))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMedicationsMedicationGlobalKeyInfiniteQueryKey = (medicationGlobalKey?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/medications/${medicationGlobalKey}`
    ] as const;
    }

export const getGetMedicationsMedicationGlobalKeyQueryKey = (medicationGlobalKey?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/medications/${medicationGlobalKey}`
    ] as const;
    }

    
export const getGetMedicationsMedicationGlobalKeyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsMedicationGlobalKeyInfiniteQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>> = ({ signal }) => getMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(medicationGlobalKey), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsMedicationGlobalKeyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>
export type GetMedicationsMedicationGlobalKeyInfiniteQueryError = ProblemDetails | ErrorDescription | ErrorApiOutContract


export function useGetMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsMedicationGlobalKeyInfiniteQueryOptions(medicationGlobalKey,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific medication by its identifier.
 */
export const prefetchGetMedicationsMedicationGlobalKeyInfiniteQuery = async <TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMedicationsMedicationGlobalKeyInfiniteQueryOptions(medicationGlobalKey,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetMedicationsMedicationGlobalKeyQueryOptions = <TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsMedicationGlobalKeyQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>> = ({ signal }) => getMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(medicationGlobalKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsMedicationGlobalKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>
export type GetMedicationsMedicationGlobalKeyQueryError = ProblemDetails | ErrorDescription | ErrorApiOutContract


export function useGetMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsMedicationGlobalKeyQueryOptions(medicationGlobalKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific medication by its identifier.
 */
export const prefetchGetMedicationsMedicationGlobalKeyQuery = async <TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMedicationsMedicationGlobalKeyQueryOptions(medicationGlobalKey,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetMedicationsMedicationGlobalKeySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsMedicationGlobalKeyQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>> = ({ signal }) => getMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsMedicationGlobalKeySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>
export type GetMedicationsMedicationGlobalKeySuspenseQueryError = ProblemDetails | ErrorDescription | ErrorApiOutContract


export function useGetMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsMedicationGlobalKeySuspenseQueryOptions(medicationGlobalKey,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMedicationsMedicationGlobalKeySuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMedicationsMedicationGlobalKeyInfiniteQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>> = ({ signal }) => getMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMedicationsMedicationGlobalKeySuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>
export type GetMedicationsMedicationGlobalKeySuspenseInfiniteQueryError = ProblemDetails | ErrorDescription | ErrorApiOutContract


export function useGetMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>>, TError = ProblemDetails | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMedicationsMedicationGlobalKeySuspenseInfiniteQueryOptions(medicationGlobalKey,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




